import React from 'react';
import { alpha } from '@mui/material/styles';
import { Card, CardProps, Button, ButtonProps, TextField, TextFieldProps, styled } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: 3,
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${alpha(theme.palette.text.primary, 0.04)}`,
}));

export const PrimaryButton = (props: ButtonProps) => (
  <Button {...props} variant="contained" color="primary" sx={{ borderRadius: 9999, textTransform: 'none', fontWeight: 700, ...props.sx }} />
);

export const OutlineButton = (props: ButtonProps) => (
  <Button {...props} variant="outlined" sx={{ borderRadius: 12, textTransform: 'none', ...props.sx }} />
);

export const StyledTextField = styled((p: TextFieldProps) => <TextField fullWidth {...p} />)({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: 'transparent',
  },
});

export default StyledCard;
